import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
import spreeStore from '../../store';
import styles from './styles/ktp-off-canvas.scss';

const KtpOffCanvas = (props) => {
    const { children, isOpen, onClose } = props;
    const componentId = 'KTP-OFF-CANVAS';
    const rootElem = document.getElementById('root');
    if (isOpen) {
        rootElem.classList.add('disabled');
        spreeStore.dispatch(actions.setBackgroundDisabled({
            triggedBy: componentId,
        }));
    } else if (spreeStore.getState().backgroundDisabled.triggedBy === componentId) {
        rootElem.classList.remove('disabled');
        spreeStore.dispatch(actions.setBackgroundDisabled({
            triggedBy: null,
        }));
    }
    const domElem = isOpen ? (
        <div className={styles.ktpOffCanvas}>
            <div className={styles.head}>
                <div className={styles.title}>
                    <FormattedMessage id="filters-title" default="Filtros" />
                </div>
                <div>
                    <button onClick={onClose} type="button">
                        <FormattedMessage id="apply" default="Aplicar" />
                    </button>
                </div>
            </div>
            <div>
                {children}
            </div>
        </div>
    ) : false;
    return domElem;
};

export default KtpOffCanvas;



/** WEBPACK FOOTER **
 ** ./src/components/shared/ktp-off-canvas.js
 **/